import { render, staticRenderFns } from "./culture.vue?vue&type=template&id=7bc1a40d&scoped=true"
import script from "./culture.vue?vue&type=script&lang=js"
export * from "./culture.vue?vue&type=script&lang=js"
import style0 from "./culture.vue?vue&type=style&index=0&id=7bc1a40d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc1a40d",
  null
  
)

export default component.exports